module.exports = __webpack_public_path__ + "img/PorkDenmark.66fbac13.png";